export const environment = {
    production: true,
    apiUrl: 'https://igestructuras.es/api/' // URL de tu backend para producción
  };
